import React, { useMemo } from "react";
import { injectIntl } from "react-intl";
import { sendPossessionEvent } from "../../../Base/Utilities/PossessionEvents";

const GoBack = (props) => {
  const { panel, updateState, useHistory, keepMainEvent, intl } = props;
  const { formatMessage } = intl;

  const swapPossession = () => {
    const tempEntities = props.currentState.entities;
    const currPossessionEntity = tempEntities.find((entity) => entity.hasPossession);
    const newPossessionEntity = tempEntities.find((entity) => !entity.hasPossession);
    currPossessionEntity.hasPossession = false;
    newPossessionEntity.hasPossession = true;
    updateState("entities", tempEntities);
    sendPossessionEvent(newPossessionEntity.entityId, "hasPossession", props);
  };

  const _goBack = () => {
    let events = props.currentState.events;
    let backStatus = props.currentState?.backStatus;
    const stepBack = backStatus?.history?.pop();
    events["main"] = events[panel?.allowBack?.event ?? "main"];
    if (panel?.allowBack?.save) {
      events["main"].back = true;
    }

    updateState("backStatus", {
      history: backStatus?.history,
    });

    if ((panel?.allowBack?.value === "useHistory" || useHistory) && stepBack) {
      if (!!props.currentState.secondary && stepBack?.workflowType === "primary") {
        updateState("secondary", null);
      } else if (!!props.currentState.primary && stepBack?.workflowType === "secondary") {
        updateState("primary", null);
      }
      updateState(stepBack?.workflowType, stepBack?.state);
      if (!keepMainEvent) {
        events.main = stepBack?.event;
      }
    } else {
      updateState(panel.allowBack.state, panel.allowBack.value);
    }

    updateState("events", events);
  };

  const isBackstepEmpty = useMemo(() => {
    if (panel?.allowBack?.value !== "useHistory" && !useHistory) {
      return false;
    }
    let backStatus = props.currentState?.backStatus;
    if (!backStatus) {
      return false;
    }
    const stepBack = backStatus.history?.at(-1);
    if (!stepBack) {
      return true;
    }
    return !stepBack.state || stepBack.state === "main-buttons";
  }, [props.currentState?.backStatus, panel?.allowBack?.value]);

  return (
    !isBackstepEmpty && (
      <div className="go-back" onClick={() => _goBack()}>
        <i className="fas fa-angle-left"></i>
        <span>
          {formatMessage({
            id: "back",
            defaultMessage: "back",
          })}
        </span>
      </div>
    )
  );
};

export default injectIntl(GoBack);
